import { MARKETING_SECTION_HEADING_HIGHLIGHT_INFO_MESSAGE } from '@modules/whitelabel-cover-page/marketing-page-section/marketing-page-section.constants';

export const STATS_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'stats-layout',
  LAYOUT_LABEL: 'Stats Cards',
  LAYOUT_IMAGE_PATH: 'https://cdn-www.topfans.com/TopFans/1785239301664.png',
  LAYOUT_DESCRIPTION: 'Three statistic cards with a section heading and subheading',
  DEFAULT_THEME_COLOR: '#00D2A6',
  BACKGROUND_IMAGE_ALT: 'Stats section background',
  LABEL_SECTION_HEADING: 'Section Heading',
  LABEL_SECTION_SUBHEADING: 'Section Subheading',
  LABEL_STAT_VALUE: 'Stat Value',
  LABEL_STAT_DESCRIPTION: 'Stat Description',
  LABEL_STAT_1_SECTION: 'Stat 1/3',
  LABEL_STAT_2_SECTION: 'Stat 2/3',
  LABEL_STAT_3_SECTION: 'Stat 3/3',
  PLACEHOLDER_ENTER_HEADING: 'Enter Heading',
  PLACEHOLDER_ENTER_SUBHEADING: 'Enter Subheading',
  PLACEHOLDER_ENTER_STAT_VALUE: 'Enter Stat Value',
  PLACEHOLDER_ENTER_STAT_DESCRIPTION: 'Enter Stat Description',
  INFO_HEADING_HIGHLIGHT: MARKETING_SECTION_HEADING_HIGHLIGHT_INFO_MESSAGE
} as const;
